<template>
  <div
    class="small-details-option-box mt-10 mb-10"
    :class="{ selected: selected }"
  >
    <cv-radio-button
      name="is-round-logo"
      :label="title"
      :checked="false"
      :value="'some'"
      @change="() => $emit('clicked')"
    />
    <span class="small-details-option-box__description">{{ description }}</span>
    <div
      v-if="isRequestLogoImprovements"
      class="small-details-option-box__beta"
    >
      {{ $t('wizard-v2.common.beta') }}
    </div>
  </div>
</template>

<script>
import { CvRadioButton } from '@carbon/vue';

export default {
  components: {
    CvRadioButton,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    selected: {
      type: Boolean,
      default: false,
    },
    isRequestLogoImprovements: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
.small-details-option-box {
  position: relative;
  border: 1px solid #e0e0e0;
  padding: 10px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  &__description {
    color: #525252;
    margin-left: 28px;
    font-size: 12px;
  }

  &__beta {
    position: absolute;
    background-color: #c6c6c6;
    color: white;
    font-size: 12px;
    padding: 2px 5px;
    right: 10px;
    border-radius: 10px;
  }

  .bx--radio-button__label {
    font-size: 16px;
  }

  &.selected {
    border: 1px solid #161616;
  }
}
</style>
